import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Components
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Features } from "./components/Features";
import { CaseStudies } from "./components/CaseStudies";
import { About } from "./components/About";
import { Team } from "./components/Team";
import { Pricing } from "./components/Pricing";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { Login } from "./components/Login";
import { AdminLayout } from "./components/AdminLayout";
import { Admin } from "./components/Admin";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ContactInquiries } from "./components/ContactInquiries";
import { NewsletterSubscriptions } from "./components/NewsletterSubscriptions";

const Home = () => {
  return (
    <div className="min-h-screen" style={{ background: 'var(--bg-primary)' }}>
      {/* Header */}
      <Header />
      
      {/* Main Content */}
      <main>
        <Hero />
        <Services />
        <Features />
        <CaseStudies />
        <About />
        <Team />
        <Pricing />
        <Contact />
      </main>
      
      {/* Footer */}
      <Footer />
      
      {/* Toast Notifications */}
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <Admin />
                </AdminLayout>
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="inquiries" />} />
            <Route path="inquiries" element={<ContactInquiries />} />
            <Route path="subscriptions" element={<NewsletterSubscriptions />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;

